import type { Subsystem } from '../../types';

/** Design facts stay visibly separate from measured values and health colours. */
export function ReferenceSpecs({ subsystem }: { subsystem: Subsystem }) {
  const reference = subsystem.reference;
  if (!reference) return null;
  return (
    <section className="space-y-2 p-2.5 text-xs" aria-label={`${subsystem.label} ${reference.basis==='illustrative'?'illustrative reference':'published specifications'}`}>
      <div className="text-[10px] uppercase tracking-wider text-ink-3">
        {reference.basis==='illustrative'?'Illustrative layout · functional reference':'Published specifications · reference'}
      </div>
      {subsystem.description && <p className="leading-relaxed text-ink-2">{subsystem.description}</p>}
      <dl className="divide-y divide-hairline">
        {reference.values.map(({ label, value }) => (
          <div key={label} className="flex justify-between gap-3 py-1.5">
            <dt className="min-w-0 flex-1 text-ink-3">{label}</dt>
            <dd className="max-w-[60%] break-words text-right font-mono text-ink">{value}</dd>
          </div>
        ))}
      </dl>
      {reference.note && <p className="leading-relaxed text-ink-3">{reference.note}</p>}
      <a
        href={reference.sourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-accent underline"
      >
        {reference.sourceTitle}
      </a>
      <p className="text-[10px] text-ink-3">
        Source checked {reference.checkedAt}. No live telemetry connected.
      </p>
    </section>
  );
}
